import { ProcessorType } from '@weave/schema-gen-ts/dist/schemas/payments/messages/values/values.pb';
import { InvoiceModel, PaymentModel, PaymentType } from '@frontend/api-invoices';

export const isCareCreditPayment = (payment?: PaymentModel) =>
  payment?.processorType === ProcessorType.CARE_CREDIT_PROCESSOR || payment?.paymentType === PaymentType.CareCredit;

export const getInvoicePayments = (invoice: InvoiceModel) =>
  [invoice.payment, ...(invoice.payments ?? [])].filter((payment): payment is PaymentModel => !!payment);

export const getCareCreditLastFour = (accountNumber?: string) => accountNumber?.replace(/\D/g, '').slice(-4);

export const getAccountLookupKey = (merchantNumber: string, phoneNumber: string) => `${merchantNumber}:${phoneNumber}`;
